import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import Button from 'flarum/common/components/Button';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
import humanTime from 'flarum/common/helpers/humanTime';
import { param, ROUTE, MEMBERS_ROUTE } from '../../common/community';

/** Members who share your places (only those who show that part of their location). */
export default class CommunityMembers extends Component {
  oninit(vnode) {
    super.oninit(vnode);
    this.group = param('group') || '';
    this.people = [];
    this.groups = [];
    this.page = 1;
    this.loading = true;
    this.more = false;
    this.broken = {};
    this.load(1);
  }
  async load(page) {
    this.loading = true;
    m.redraw();
    try {
      const r = await app.request({
        method: 'GET',
        url: app.forum.attribute('apiUrl') + '/voucha-community/members?group=' + encodeURIComponent(this.group) + '&page=' + page,
        errorHandler: () => {}
      });
      this.state = r.state;
      if (r.state === 'ok') {
        this.groups = r.groups;
        this.group = r.group;
        this.page = r.page;
        this.people = page === 1 ? r.people : this.people.concat(r.people);
        this.more = r.people.length === r.perPage;
      }
    } catch (e) {
      this.state = app.session.user ? 'error' : 'guest';
    }
    this.loading = false;
    m.redraw();
  }
  view() {
    if (!app.session.user || this.state === 'guest') {
      return m("div", {
        className: "VouchaMembers VouchaSetup"
      }, "Log in to see members near you and from home.");
    }
    if (this.state === 'setup') {
      return m("div", {
        className: "VouchaMembers VouchaSetup"
      }, m("p", null, "Set up My Community first, so we know who's near you."), m("a", {
        className: "Button Button--primary",
        href: app.route(ROUTE)
      }, "Set up My Community"));
    }
    if (this.state === 'error') return m("div", {
      className: "VouchaMembers VouchaSetup"
    }, "Members couldn't load. Please refresh the page.");
    return m("div", {
      className: "VouchaMembers"
    }, m("nav", {
      className: "VouchaMembers-tabs"
    }, this.groups.map(g => m("a", {
      className: 'VouchaCommunity-tab' + (g.key === this.group ? ' is-active' : ''),
      href: app.route(MEMBERS_ROUTE, {
        group: g.key
      })
    }, g.label, " ", m("span", null, g.count)))), this.loading && this.page === 1 ? m(LoadingIndicator, null) : this.people.length ? m("div", {
      className: "VouchaMembers-grid"
    }, this.people.map(p => m("a", {
      className: "VouchaMembers-card",
      href: app.route('user', {
        username: p.username
      })
    }, m("span", {
      className: "VouchaMembers-avatar"
    }, p.avatarUrl && !this.broken[p.username] ? m("img", {
      src: p.avatarUrl,
      alt: "",
      loading: "lazy",
      onerror: () => {
        this.broken[p.username] = true;
        m.redraw();
      }
    }) : (p.displayName || '?').charAt(0).toUpperCase()), m("span", {
      className: "VouchaMembers-body"
    }, m("strong", null, p.displayName), p.living ? m("small", null, m("i", {
      className: "fas fa-map-marker-alt"
    }), " ", p.living) : null, p.home ? m("small", null, m("i", {
      className: "fas fa-home"
    }), " ", p.home) : null, p.origin ? m("small", null, m("i", {
      className: "fas fa-seedling"
    }), " From ", p.origin) : null, p.profession ? m("small", null, m("i", {
      className: "fas fa-briefcase"
    }), " ", p.profession) : null, p.study ? m("small", null, m("i", {
      className: "fas fa-graduation-cap"
    }), " ", p.study) : null, m("small", {
      className: "VouchaMembers-meta"
    }, p.posts, " posts", p.joinedAt ? [' · joined ', humanTime(new Date(p.joinedAt))] : null))))) : m("div", {
      className: "VouchaEmpty"
    }, m("i", {
      className: "fas fa-user-friends",
      "aria-hidden": "true"
    }), m("strong", null, "No one here yet"), m("p", null, "As more members set up My Community, they'll appear here. Invite a friend from home!")), this.more ? m("div", {
      className: "VouchaSetup-more"
    }, m(Button, {
      className: "Button",
      loading: this.loading,
      onclick: () => this.load(this.page + 1)
    }, "Show more")) : null);
  }
}
flarum.reg.add('voucha-community', 'forum/components/CommunityMembers', CommunityMembers);